export default __webpack_public_path__ + "static/media/g2021-3.d49a66d5.jpeg";